<div class="flex-1 overflow-y-auto min-h-[calc(100dvh-80px)]">
  <app-page-header
    [title]="'pages.help' | transloco"
  />

  <p-tabs
    [value]="currentTab"
    [dt]="{
      tablistBackground: 'transparent',
      tabBorderWidth: '0 0 2px 0',
      tabBackground: 'transparent',
      tabActiveBackground: 'transparent'
    }"
  >
    <p-tablist>
      @for (tab of tabs; track tab.route) {
        <p-tab
          [value]="tab.route"
          [routerLink]="tab.route"
          class="flex items-center !gap-2 text-inherit"
        >
          <lucide-icon [name]="tab.icon" [size]="18" />
          <span>{{ tab.labelKey | transloco }}</span>
        </p-tab>
      }
    </p-tablist>
  </p-tabs>

  <div class="mt-6">
    <router-outlet />
  </div>
</div>
